// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Pe","innerTile":"Qe","heading":"Re","instaTileBtn":"Se","disabled":"Te","instaTileElement":"Ue","instagramPic":"Ve"};